import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const YoutubeDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.youtube9-16_svg__cls-4{fill:#9e9e9e}'}</style>
    </defs>
    <g id="youtube9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="youtube9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v257.6a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31V21.64A14.31 14.31 0 00124 7.33z"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path
          d="M138.29 21.64A14.31 14.31 0 00124 7.33h-14.14v1.92a7.59 7.59 0 01-7.59 7.59H43.16a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.3 21.64v225.17h132V39.65z"
          fill="#e62d27"
        />
        <path fill="#f5f5f5" d="M6.3 246.81h131.96v25.39H6.3z" />
        <path className="youtube9-16_svg__cls-4" d="M29.96 260.87h21.38v3.94H29.96zM29.96 254.86h34.36v4.21H29.96z" />
        <circle cx={20.21} cy={260.73} r={6.55} fill="#424242" />
        <rect x={100.05} y={255.75} width={28.09} height={9.87} rx={2.89} fill="#4286f5" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default YoutubeDevice916;
